import React from 'react';
import Grid from '@mui/material/Grid';
import './styles.scss';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import BottomArrowNavButton from '../BottomArrowNavButton';
import { scrollVertically } from '../../../../utils';

const StartHere = ({ calculateRef }) => {
  const mobileScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const mobileCellScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Grid container className='start-here'>
      <Container sx={{ mt: { xs: 11, customheadermobile: 1 }, px: { xs: '15px', sm: '24px' } }}>
        <Grid container>
          <Grid item xs={12} sm={12} customhomepagetablet={6} md={7} sx={{ mt: { xs: 4, md: 13 }, pr: { xs: 0, sm: '15px' } }}>
            <Box>
              <Typography className='start-here-text fist-line' variant='span'>
                By &nbsp;
              </Typography>
              <Typography className='start-here-text fist-line green-bg' variant='span'>
                                &nbsp; 2033 &nbsp;
              </Typography>
              <Typography className='start-here-text' variant='span'>
                ,
                <br />
                The Social Security Administration OASI Trust Fund is projected
                to become depleted with&nbsp;
              </Typography>
              <Typography className='no-wrap-text start-here-text green-bg' variant='span'>
                                &nbsp; 77% &nbsp;
              </Typography>
              <Typography className='start-here-text' variant='span'>
                                &nbsp; of
                {!mobileScreen && <br />}
                {' benefits payable at that '}
                time.
              </Typography>
              <Box className='sub-title green-box' p={{ sm: 1 }}>
                <Typography
                  className='start-here-text bigger-text'
                  variant='span'
                >
                  How could this impact your retirement plan?
                </Typography>
              </Box>
            </Box>
            {mobileCellScreen && (
            <Box mt={2}>
              <Typography className='start-here-card disclaimer' variant='span'>
                Source: The 2025 Annual Report of the Board of Trustees of the
                Federal Old-Age and Survivors Insurance and Federal Disability
                <span className='no-wrap-text'> Insurance Trust Funds.</span>
              </Typography>
            </Box>
            )}
          </Grid>
          <Grid item xs={12} sm={12} customhomepagetablet={6} md={5} mt={{ xs: 2, md: 7 }} mb={{ xs: 0, sm: 3 }} pl={{ md: 10, xs: 0 }}>
            <Paper className='right-card'>
              <Box pt={8} sx={{ display: { xs: 'none', md: 'block' } }}>
                <Typography
                  className='start-here-card arrow-text'
                  variant='span'
                  pl={4}
                  pr={3}
                  pt={1}
                  pb={1}
                >
                  Start Here
                </Typography>
              </Box>
              <Box component='span' className='green-arrow' sx={{ display: { xs: 'none', md: 'block' } }} />
              <Box m={{ xs: 3, sm: 4 }}>
                <Box pt={{ xs: 6, md: 2 }}>
                  <Typography className='start-here-card lifetime-title'>
                    Lifetime
                    <br />
                    Social Security
                  </Typography>
                </Box>
                <Box>
                  <Typography className='start-here-card benefit-title'>
                    Benefit Estimator
                  </Typography>
                </Box>
                <Box pt={2} pb={{ xs: 0, sm: 4 }}>
                  <Typography className='start-here-card description'>
                    Find out how potential reductions in Social Security can
                    impact your retirement income.
                  </Typography>
                </Box>
                <Box pb={2}>
                  <Button
                    variant='contained'
                    className='primary-btn start-here-calculate'
                    onClick={() => calculateRef.current.scrollIntoView()}
                  >
                    <span>
                      {'Calculate My Potential '}
                      <span className='no-wrap-text'>Benefit Reduction</span>
                    </span>
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>

        <Grid item xs={12} textAlign={!mobileScreen ? 'center' : 'left'} pt={0} mb={{ xs: 5 }} mt={{ xs: -1.5, mt: 0 }}>
          { !mobileCellScreen && (
          <Typography className='start-here-card disclaimer' variant='span'>
            Source: The 2025 Annual Report of the Board of Trustees of the
            Federal Old-Age and Survivors Insurance and Federal Disability
            <span className='no-wrap-text'> Insurance Trust Funds.</span>
          </Typography>
          )}
          {!mobileScreen && (
            <Box ml={-4} mt={4}>
              <Button
                className='start-here-scroll-down-button'
                onClick={() => scrollVertically()}
              >
                <Box pt={2.5}>
                  <BottomArrowNavButton />
                </Box>
              </Button>
              <Box className='scroll-down-container'>
                <Typography mt={-6.5} className='start-here-card scroll-down'>
                  Scroll Down
                  <br />
                  to Learn More
                </Typography>
              </Box>
            </Box>
          )}
        </Grid>
      </Container>
    </Grid>
  );
};

StartHere.propTypes = {
  calculateRef: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.shape()]),
};

StartHere.defaultProps = {
  calculateRef: undefined,
};

export default StartHere;
